<div
  #trigger
  class="smart-select-trigger smart-input"
  tabindex="0"
  (click)="toggle()"
  (blur)="onTouched()"
  [class.disabled]="disabled"
  [class.opened]="isOpen()"
  [style.width]="width"
  [style.height]="height" >

  <div class="smart-select-text">
    @if (displayValue()) {
      <span class="value-text">{{ displayValue() }}</span>
    } @else {
      <span class="placeholder">{{ placeholder }}</span>
    }
  </div>

  <div class="smart-select-arrow">
    <svg viewBox="0 0 24 24" width="18" height="18">
      <path d="M7 10l5 5 5-5z" fill="currentColor"/>
    </svg>
  </div>
</div>

<ng-template #panel>
  <div class="smart-select-panel" role="listbox">
    @for (vm of viewModels(); track vm.value) {
      <div
        smartOption
        [id]="'option_slot_' + (vm.raw?.id ?? 'null')"
        [item]="vm.raw"
        class="smart-option"
        [class.selected]="selectable && isSelected(vm.raw)"
        [class.active]="selectable && optionRef.isActive()"
        [class.disabled]="selectable && vm.disabled"
        [class.read-only]="!selectable"
        [class.single-line]="singleLineOption"
        (click)="onItemClick(vm.raw)"
        #optionRef="smartOption"
        [style.height]="optionHeight">

        <span class="option-label">
          @if (itemTemplate) {
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: vm.raw }"></ng-container>
          } @else {
            {{ vm.label }}
          }
        </span>

        @if(selectable && isSelected(vm.raw)) {
          <span class="check-icon">✓</span>
        }
      </div>
    } @empty {
      <div class="no-data">Aucune option disponible</div>
    }
  </div>
</ng-template>